export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-960-33e777c906bd27c84fb8d1bf3f5e0749.webp";